module.exports = __webpack_public_path__ + "logomark11.png?db5ca4ed9a84b1bb0cf6e36ef0a3b2da";